import QuizList from "./QuizList";

export default QuizList